import { render, staticRenderFns } from "./sso.vue?vue&type=template&id=fc352d82&"
import script from "./sso.vue?vue&type=script&lang=js&"
export * from "./sso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc352d82')) {
      api.createRecord('fc352d82', component.options)
    } else {
      api.reload('fc352d82', component.options)
    }
    module.hot.accept("./sso.vue?vue&type=template&id=fc352d82&", function () {
      api.rerender('fc352d82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/sso.vue"
export default component.exports